import { cn } from '@/lib/utils';
import { useStore } from '@nanostores/react';
import { FC } from 'react';

type LeftNavItemProps = {
  text: string;
  icon: JSX.Element;
  onClick?: () => void;
  isCollapsed: boolean;
  routes?: (RegExp | undefined)[];
};

function isActive(
  associatedRoutesRegexes?: (RegExp | undefined)[],
  currentRoute?: string,
): boolean {
  if (currentRoute === undefined) return false;

  if (!associatedRoutesRegexes) return false;

  // Check if the current route matches any of the associated regular expressions
  const isRouteMatch = associatedRoutesRegexes.some(regexStr => {
    if (!regexStr) return false;
    const regex = new RegExp(regexStr);
    return regex.test(currentRoute);
  });

  return isRouteMatch;
}

export const LeftNavItem: FC<LeftNavItemProps> = ({
  text,
  icon,
  onClick,
  isCollapsed,
  routes,
}) => {
  const page = useStore($router);

  return (
    <a
      onClick={onClick}
      className={cn(
        isActive(routes, page?.path) && 'rounded-md bg-slate-100',
        'group flex items-center gap-x-3 rounded-md text-sm font-semibold leading-6',
        { 'justify-center': isCollapsed, 'justify-start': !isCollapsed },
        'hover:w-full hover:cursor-pointer hover:bg-accent hover:text-accent-foreground',
      )}
    >
      <li
        className={cn(
          'text-foreground',
          'flex items-center gap-x-3 rounded-md p-2 text-sm font-semibold leading-6',
          { 'justify-center': isCollapsed, 'justify-start': !isCollapsed },
        )}
      >
        <span className="flex-shrink-0 text-foreground dark:text-primary-foreground">
          {icon}
        </span>
        {!isCollapsed && (
          <span className="flex-grow text-foreground dark:text-primary-foreground">
            {text}
          </span>
        )}
      </li>
    </a>
  );
};
